var exports = {
  "q": "selfAssignButton__dJhci4",
};

module.exports = exports;
